module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": 0
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.errorMessage) ? _c('v-alert', {
    staticClass: "ma-2",
    attrs: {
      "value": true,
      "type": "error",
      "outline": "",
      "outlined": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.statementClients.length === 0) ? _c('v-alert', {
    staticClass: "ma-2",
    attrs: {
      "value": true,
      "type": "warning",
      "outline": "",
      "outlined": ""
    }
  }, [_vm._v("\n        Warning: could not find any contacts to send this statement to\n      ")]) : _vm._e(), _vm._v(" "), (_vm.statement) ? _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("post_add")]), _vm._v("\n        " + _vm._s(_vm.statement.title) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs-only"
  }, [_c('strong', {
    staticClass: "mr-2"
  }, [_vm._v("Closing balance:")]), _vm._v(" " + _vm._s(_vm.formatCurrency(_vm.$store.getters.settings.currency, _vm.statement.closing_balance)) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.statement) ? _c('send-template', {
    attrs: {
      "template": "STATEMENT",
      "template-context": "Statement",
      "title": "Who would you like to send this statement to?",
      "initial-page": 1,
      "clients": _vm.statementClients,
      "context": _vm.statement,
      "send-to-me": true,
      "with-send": false,
      "touch": _vm.toucher
    },
    on: {
      "sender": _vm.setSender,
      "recipients": _vm.setRecipients
    }
  }) : _c('div', [_vm._v("Unable to provide sendiing options. Please try again")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.canSend,
      "loading": _vm.sending,
      "color": "primary"
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Send")])], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', {
    attrs: {
      "value": 1
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center",
    staticStyle: {
      "max-width": "500px",
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('v-icon', {
    staticClass: "mt-4",
    attrs: {
      "dark": "",
      "size": "76",
      "color": "green"
    }
  }, [_vm._v("\n          check_circle\n        ")]), _vm._v(" "), _c('h3', {
    staticClass: "subheading text-xs-center mb-4"
  }, [_vm._v("\n          Statement sent\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "overline text-xs-left ml-4"
  }, [_vm._v("Messages:")]), _vm._v(" "), (_vm.batchId) ? _c('batch-id-list', {
    staticClass: "pb-4",
    attrs: {
      "batch-id": _vm.batchId
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4670fb78","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/Statement/SendStatement.vue
// module id = 1413
// module chunks = 9